module.exports = __webpack_public_path__ + "img/rank-3.3db82f66.svg";